import * as React from "react";
import { SVGProps, useEffect } from "react";
import { useLocation } from "react-router";

interface Props extends SVGProps<SVGSVGElement> {}

export const ProgressCounter = (props: Props) => {
    const location = useLocation();
    const [step, setStep] = React.useState(1);

    useEffect(() => {
        setStep(parseInt(window.location.pathname.split("/").pop() as string) || 1);
    }, [location.pathname]);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            // Original drawing is 350×30. Add a 1px bleed each side for the 3px strokes.
            viewBox="-1 -1 352 32"
            preserveAspectRatio="xMidYMid meet"
            className="progress-counter"
            style={{ overflow: "visible" }}
            {...props}
        >
            {/* Filled progress dots */}
            <g fill="#425b66">
                <circle cx="15" cy="15" r="7" />
                {step >= 2 && <circle cx="79" cy="15" r="7" />}
                {step >= 3 && <circle cx="143" cy="15" r="7" />}
                {step >= 4 && <circle cx="207" cy="15" r="7" />}
                {step >= 5 && <circle cx="271" cy="15" r="7" />}
                {step >= 6 && <circle cx="335" cy="15" r="7" />}
            </g>

            {/* Rings + connectors */}
            <g fill="none" stroke="#6c93a6" strokeWidth="3" opacity="0.7">
                {/* Rings (centres exactly match the filled dots) */}
                <circle cx="15" cy="15" r="13.5" />
                <circle cx="79" cy="15" r="13.5" />
                <circle cx="143" cy="15" r="13.5" />
                <circle cx="207" cy="15" r="13.5" />
                <circle cx="271" cy="15" r="13.5" />
                <circle cx="335" cy="15" r="13.5" />

                {/* Connectors */}
                <path d="M28.5 15.5 h37" />
                <path d="M92.5 15.5 h37" />
                <path d="M156.5 15.5 h37" />
                <path d="M220.5 15.5 h37" />
                <path d="M284.5 15.5 h37" />
            </g>
        </svg>
    );
};
